import { createFileRoute } from "@tanstack/react-router";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import BulkBundleCreateForm from "./-form";
import { BulkBundleCrumbs } from "./-crumbs";

export const Route = createFileRoute(
  "/_private/_practice-360/bulk-bundle/create",
)({
  component: BulkBundleCreatePage,
});

function BulkBundleCreatePage() {
  return (
    <div>
      <title>Create Bulk Bundle - Legrande Health Portal</title>
      <BulkBundleCrumbs />
      <Card>
        <CardHeader>
          <CardTitle>Create Bulk Bundle</CardTitle>
          <CardDescription>Enter bundle details below.</CardDescription>
        </CardHeader>
        <CardContent>
          <BulkBundleCreateForm />
        </CardContent>
      </Card>
    </div>
  );
}
